<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full">
        <router-link to="/master">
          <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-8 w-8" />
        </router-link>
      </div>
      <div
        v-if="
          permissionPageAccessArry.includes(PermissionVariables.SettingsAdd) ||
            loginUserRole == 'Admin'
        "
        class="vx-col w-full mb-base"
      >
        <TDSForm />
      </div>

      <div class="vx-col w-full">
        <vs-tabs>
          <vs-tab
            v-if="
              permissionPageAccessArry.includes(
                PermissionVariables.SettingsAdd
              ) ||
                permissionPageAccessArry.includes(
                  PermissionVariables.SettingsView
                ) ||
                loginUserRole == 'Admin'
            "
            label="TDS List"
            icon-pack="feather"
            icon="icon-box"
          >
            <div class="tab-text">
              <div>
                <TDSList />
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import TDSForm from "@/views/apps/masters/tds/TDSForm.vue";
import TDSList from "@/views/apps/masters/tds/TDSList.vue";
import PermissionVariables from "@/services/UserManagementVaraibles.js";

export default {
  components: {
    TDSForm,
    TDSList,
  },

  data() {
    return {
      permissionPageAccessArry: window.localStorage.getItem(
        "permissionPageAccess"
      )
        ? localStorage.getItem("permissionPageAccess").split(",")
        : "",
      PermissionVariables: PermissionVariables,
      loginUserRole: window.localStorage.getItem("UserRole"),
    };
  },
};
</script>
